export default {
  translations: {
    login: {
      login: "Login",
      noAccount: "Don't have an account?",
      haveAccount: "Have an account?",
      register: "Register",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm password",
      forgotPassword: "Forgot password?",
      resetPassword: "Reset password",
      resetCode: "Reset code",
      passwordDoesNotMatch: "Password does not match",
      name: "Name",
      lastname: "Lastname",
      sex: "Sex",
      birthday: "Birthday",
      mobileNumber: "Mobile phone",
      country: "Country",
      city: "City",
      healthCenter: "Health Center",
      licenceNumber: "Licence Number",
      cv: "Curriculum Vitae",
      language: "Language",
      accountStatus: "Account Status",
      firstRegistration: "First registration",
      speciality: "Speciality",
      bio: "Bio",
      subscriptionStatus: "Subscription Status",
      tier: "Tier",
      startDate: "Start date",
      remainingDays: "Remaining days",
      blockLog: "Blocks log",
    },
    registerDoctor: {
      ok: "OK",
      okRegister: "Application submitted successfullt",
      okContact: "We will contact you soon.",
      apply: "Apply to become part of TeleShëndet platform.",
      note: 'By clicking "Register", you agree to TeleShendet Terms of Use and Privacy Policy. You consent to receive phone calls and SMS messages from TeleShendet in order to connect you with the patients. Message frequency depends on your activity. Message and data rates may apply. You may opt-out by contacting us at info@teleshendet.al.',
      termsOfUse: "Terms of Service",
      privacyPolicy: "Privacy Policy",
      agreeTo: "I agree to the ",
    },
    forms: {
      sendResetCode: "Send reset code",
      clear: "Clear",
      requiredField: "Mandatory field",
      slideOrClick: "Click or slide a file.",
      uploading: "Uploading...",
      delete: "Remove",
      size: "Size",
    },
    patients: {
      shortTitle: "Pacientë",
      title: "Lista e pacientëve",
      name: "Emri",
      email: "E-mail",
      phone: "Telefoni",
      tier: "Paketa",
      startDate: "Data fillimit",
      expirationDate: "Data skadimit",
      registrationDate: "Data e rregjistrimit",
      none: "Asnjë",
      patient: "Pacienti",
      medicalCards: {
        title: "Lista e vizitave",
        doctor: "Mjeku",
        documents: "Dokumenta",
        comments: "Komente",
        date: "Data",
        add: "Shto vizitë",
        symtopms: "Simptoma/Ankesa",
        diagnosis: "Diagnoza",
        recommendations: "Rekomandime",
        recipe: "Receta",
        privateNote: "Komente të tjera mjekësore",
        success: "Sukses",
        createdSuccessfuly: "Vizita u shtua",

        detailsTab: {
          title: "Detaje & Komente",
          details: "Të dhënat e vizitës",
          comments: "Komente",
          download: "Shkarko",
          recipe: "Receta",
          comment: "Komenti",
          commentAdded: "Komenti u shtua",
          commentEdited: "Komenti u redaktua",
          commentDeleted: "Komenti u fshi",
          accounts: "Llogaritë",
          visitOnDate: "Vizita e datës {{date}}",
        },

        documentsTab: {
          title: "Dokumenta",
          details: "Të dhënat e dokumentit",
          list: "Lista e dokumentave",
          author: "Autori",
          description: "Përshkrimi",
          upload: "Ngarko",
          documentAdded: "Dokumenti u ruajt",
          documentDeleted: "Dokumenti u fshi",
          add: "Shto një dokument",
          document: "Dokumenti",
          documentByName: "Dokumenti {{name}}",
          formatNotSupported:
            "Skedari i formatit <small>{{format}}</small> nuk mund të shfaqet por ju mund ta shkarkoni dhe ta hapni nga kompjuteri.",
        },
      },
      temporaryBlock: {
        title: "Temporary block",
        duration: "Duration",
        reason: "Reason",
      },
    },
    selected: "selected",
    language: "Language",
  },
};
